import wands from './Wands'
import cups from './Cups'
import swords from './Swords'
import pentacles from './Pentacles'

const minorArcana = [...wands, ...cups, ...swords, ...pentacles]

export default minorArcana;